import { render, staticRenderFns } from "./ConfirmMail.vue?vue&type=template&id=1c1d01e8"
import script from "./ConfirmMail.vue?vue&type=script&lang=js"
export * from "./ConfirmMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c1d01e8')) {
      api.createRecord('1c1d01e8', component.options)
    } else {
      api.reload('1c1d01e8', component.options)
    }
    module.hot.accept("./ConfirmMail.vue?vue&type=template&id=1c1d01e8", function () {
      api.rerender('1c1d01e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/ConfirmMail.vue"
export default component.exports